import { Button, MAGNETIC_TOKENS } from '@appd/uik';
import { getActionsRegistry } from '../../../modules/actions';
import { useRouter } from 'next/router';
import { UNDO_REDO_EVENT_TYPE } from '../../../hooks';

interface DashifyEditorHeaderControlsProps {
  template: any;
  isEditMode: boolean;
  isWidgetEditMode: boolean;
  canUndo: boolean;
  canRedo: boolean;
  onAddWidget: () => void;
  onCancel: () => void;
  onSave: () => void;
  undoRedoEvent: (eventType: UNDO_REDO_EVENT_TYPE) => void;
}

const {
  COLORS: { DEFAULT_BG_WEAK, DEFAULT_TEXT },
  PARTICLE: { COLOR_SCHEME },
  TYPOGRAPHY: { BODY },
} = MAGNETIC_TOKENS;

/**
 * should extend class ActionManager
 */
export const DashifyEditorHeaderControls: React.FC<DashifyEditorHeaderControlsProps> = ({
  template,
  isEditMode,
  isWidgetEditMode,
  canUndo,
  canRedo,
  onAddWidget,
  onCancel,
  onSave,
  undoRedoEvent,
}) => {
  const router = useRouter();
  const actionsRegistry = getActionsRegistry(router);

  const onClick = (callbackFn: Function) => {
    router.replace(`/${router.query.appName}/${template.name}${isEditMode ? '' : '/edit'}`);
    callbackFn();
  };

  const addDashlet = () => {
    actionsRegistry.addDashlet.onClick();
  };

  return (
    <div className="flex w-full items-center px-2 border-b-2 h-12" style={{ backgroundColor: DEFAULT_BG_WEAK }}>
      <div className="flex gap-2 mr-auto">
        {isWidgetEditMode && (
          <>
            <Button
              type="TERTIARY"
              icon="Action.Undo"
              disabled={!canUndo}
              onClick={() => undoRedoEvent(UNDO_REDO_EVENT_TYPE.Undo)}
            />
            <Button
              type="TERTIARY"
              icon="Action.Redo"
              disabled={!canRedo}
              onClick={() => undoRedoEvent(UNDO_REDO_EVENT_TYPE.Redo)}
            />
          </>
        )}
        {isEditMode && (
          <>
            <Button type="TERTIARY" icon="Action.Add" onClick={onAddWidget}>
              Add Widget
            </Button>
          </>
        )}
      </div>
      <div className="flex gap-2 ml-auto">
        <Button data-testid="dashify-editor-header-cancel" type="SECONDARY" onClick={() => onClick(onCancel)}>
          Cancel
        </Button>
        <Button data-testid="dashify-editor-header-save" onClick={() => onClick(onSave)}>
          Save
        </Button>
      </div>
    </div>
  );
};
